import { createApiRequest } from "../common";
import { UpdateOrgCustomRoleRequestContent as UpdateOrgCustomRoleRequestContentv2, UpdateOrgCustomRoleResponseContent as UpdateOrgCustomRoleResponseContentv2 } from '@equaliq/api-model';
import { UpdateOrgCustomRoleRequestContent, UpdateOrgCustomRoleResponseContent } from '@equaliq/api-model';

export const updateOrgCustomRoleApi = async (request: UpdateOrgCustomRoleRequestContent): Promise<UpdateOrgCustomRoleResponseContent> => {
  const apiRequest = createApiRequest<UpdateOrgCustomRoleResponseContent>('post', '/orgs/roles/update');
  return apiRequest(request);
};

export const updateOrgCustomRoleApiv2 = async (request: UpdateOrgCustomRoleRequestContentv2): Promise<UpdateOrgCustomRoleResponseContentv2> => {
  const apiRequest = createApiRequest<UpdateOrgCustomRoleResponseContentv2>('post', '/orgs/roles/update');
  return apiRequest(request);
};
